import type { SportId } from '../types/sports';
import { type ObjectValuesUnionType } from '../utils/typing';

export const SportListItemTypes = Object.freeze({
  SEE_ALL: 'seeallrow',
  TOP_COMPETITIONS: 'topcompetitions',
  COMPETITIONS: 'competitions',
  HEADER: 'header',
  LIST: 'list',
  ROW: 'row',
});
export type SportListItemType = ObjectValuesUnionType<typeof SportListItemTypes>;

export type SportsMenuItem = {
  id: string;
  type: SportListItemType;
  expandId?: string;
  sportId?: SportId;
  flagId?: string;
  label: string;
  expandable?: boolean;
  to?: string;
  content?: Array<SportsMenuItem>;
  showNewTag?: boolean;
  categoryId?: number;
};
